import React from "react";
import Layout from "components/Layout";
import FullSpinner from "components/FullSpinner";
import { redirectDefaultHubRoute } from "utils/hooks/hub";

const HubIndex = () => {
  redirectDefaultHubRoute();

  return (
    <Layout>{() => <FullSpinner title="Preparing your dashboard" />}</Layout>
  );
};

export default HubIndex;
